export const ActionTypes = {
  FETCH_GLOBAL_FACTORY: 'services/dashboards/global/fetch_global_factory',
  SET_GLOBAL_FACTORY: 'services/dashboards/global/set_global_factory',
  FETCH_GLOBAL_DASHBOARD: 'services/dashboards/global/fetch_global_dashboard',
  FETCH_FACTORY_CONFIG: 'services/dashboards/global/fetch_factory_configuration',
  SET_GLOBAL_DASHBOARD: 'services/dashboards/global/set_global_dashboard',
  SET_FACTORY_CONFIG: 'services/dashboards/global/set_factory_configuration',
  SET_LOADER_STATUS: 'services/dashboards/global/set_loader_status',
  FETCH_C_SUITE_MAP_VIEW_GLOBAL_DASHBOARD: 'services/common/fetch_c_suite_map_view_global_dashboard',
  FETCH_RELEASE_VERSION: 'services/common/fetch_release_version',
  SET_RELEASE_VERSION: 'services/common/set_release_version',
};
const fetchGlobalFactory = ({ globalFactoryParams }) => ({
  globalFactoryParams,
  type: ActionTypes.FETCH_GLOBAL_FACTORY,
});

const setGlobalFactory = ({ globalFactory }) => ({
  globalFactory,
  type: ActionTypes.SET_GLOBAL_FACTORY,
});
const fetchMapGlobalDashboard = ({ currentView }) => ({
  currentView,
  type: ActionTypes.FETCH_C_SUITE_MAP_VIEW_GLOBAL_DASHBOARD,
});
const fetchGlobalDashboard = ({ globalDashboardParams }) => ({
  globalDashboardParams,
  type: ActionTypes.FETCH_GLOBAL_DASHBOARD,
});
const fetchFactoryConfig = ({ globalDashboardParams }) => ({
  globalDashboardParams,
  type: ActionTypes.FETCH_FACTORY_CONFIG,
});

const setGlobalDashboard = ({ globalDashboardResult }) => ({
  globalDashboardResult,
  type: ActionTypes.SET_GLOBAL_DASHBOARD,
});

const setFactoryConfig = ({ factoryConfigResult }) => ({
  factoryConfigResult,
  type: ActionTypes.SET_FACTORY_CONFIG,
});

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

const fetchReleaseVersion = () => ({
  type: ActionTypes.FETCH_RELEASE_VERSION,
});

const setReleaseVersion = ({ versionData }) => ({
  versionData,
  type: ActionTypes.SET_RELEASE_VERSION,
});

export default {
  fetchGlobalFactory,
  setGlobalFactory,
  fetchGlobalDashboard,
  fetchMapGlobalDashboard,
  fetchFactoryConfig,
  setGlobalDashboard,
  setFactoryConfig,
  setLoader,
  fetchReleaseVersion,
  setReleaseVersion,
};
